import { apiFetchWithStatus } from "@/lib/api";
import { type RealtimeModelUpgrade, RealtimeModelUpgradeSchema } from "@/types/realtimeModelUpgrade";
import { GAIL_API } from "@/utils/common/constants/routes";

export class RealtimeModelUpgradeError extends Error {
  /** HTTP status, or 0 when the request never completed or the body didn't parse. */
  constructor(readonly status: number) {
    super(`Realtime model upgrade request failed (${status})`);
    this.name = "RealtimeModelUpgradeError";
  }
}

/** The backend picks the model from the org's tier; the UI never sends one. */
export async function applyRealtimeModelUpgrade(): Promise<RealtimeModelUpgrade> {
  const response = await apiFetchWithStatus<unknown>(
    `${GAIL_API}/.internal/organization/realtime-model/upgrade`,
    "POST"
  );
  if (!response.success) throw new RealtimeModelUpgradeError(response.status);

  const parsed = RealtimeModelUpgradeSchema.safeParse(response.data);
  if (!parsed.success) throw new RealtimeModelUpgradeError(0);
  return parsed.data;
}
